import { Handle, Position, type NodeProps } from '@xyflow/react';
import { PhoneOff } from 'lucide-react';
import { useIvrEditor } from '../../context';
import { NodeCard } from '../NodeCard';

/** Terminal node. No configuration; no source handle (calls end here). */
export function HangupNode(props: NodeProps) {
  const { onRemove, readOnly } = useIvrEditor();
  return (
    <>
      <Handle
        type="target"
        position={Position.Left}
        className="!h-3 !w-3 !border-2 !border-white !bg-slate-500"
      />
      <NodeCard
        verb="hangup"
        icon={PhoneOff}
        label="Hangup"
        summary="Call ends"
        configurable={false}
        removable={!readOnly}
        onRemove={() => onRemove(props.id)}
        status="configured"
        selected={props.selected}
      />
    </>
  );
}